import pbiSettingService from '@services/pbiSetting/pbiSettingService'
import { action, observable } from 'mobx'

class PbiSettingStore {
  @observable isLoading!: boolean
  @observable pbiSettingData: any = {}

  constructor() {}

  @action
  async update(body: any) {
    this.isLoading = true
    await pbiSettingService.update(body).finally(() => (this.isLoading = false))
  }

  @action
  async get() {
    this.isLoading = true
    let result = await pbiSettingService
      .get()
      .finally(() => (this.isLoading = false))
    this.pbiSettingData = result
  }
}

export default PbiSettingStore
